import { Injectable } from '@angular/core';
import { environment } from "../../environments/environment"
import { HttpClient, HttpHeaders ,HttpParams} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class InsuranceService {

  constructor(private http:HttpClient) {

  }

  SearchFlight(result:any){
    let headers = new HttpHeaders();
    return this.http.post(environment.API_URL+"/api/product/insurance/_source/nivabupa/plan-search",result,{headers : headers,observe:"response"});

  }
  SearchTripType(){
    let headers = new HttpHeaders();
    return this.http.get(environment.API_URL+"/api/product/insurance/config/_source-master-items/nivabupa",{headers : headers,observe:"response"});

  }


  generateBookingInsurance(request:any){
    return this.http.post(environment.API_URL+"/api/order/insurance/v1",request,{observe:"response"});

  }

saveCommercial(result:any) {
   
  let headers = new HttpHeaders();
  return this.http.post(environment.API_URL+"/api/insurance-commercial/insurance/plan",result,{observe:"response"});
 }
  
 commercialList(id:any) {
   if(id){
    return this.http.get(environment.API_URL+"/api/insurance-commercial/insurance/list/user/plan/"+id,{observe:"response"});
   }else{
  return this.http.get(environment.API_URL+"/api/insurance-commercial/insurance/list/plan",{observe:"response"});
 }
 }
  

 

 countryList() {
 
 return this.http.get(environment.API_URL+"/api/product/insurance/_source/nivabupa/geography-country",{observe:"response"});

}

 updateCommercial(result:any,updateId:any) {
  let headers = new HttpHeaders();
  return this.http.put(environment.API_URL+"/api/insurance-commercial/insurance/plan/"+updateId,result,{observe:"response"});
 }
 getInsuranceDatabyOrderID(OrderID:any){
    let header = new HttpHeaders();
    let httpParam : HttpParams=new HttpParams();
      return this.http.post( environment.API_URL+"/api/order/insurance/details/v1/"+OrderID ,{headers : header, observe : "body", params : httpParam,responseType : "json"})  
  
 }
 getbooking(orderId:any) {
  let header = new HttpHeaders();
  let httpParam : HttpParams=new HttpParams();
    return this.http.post( environment.API_URL+"/api/order/insurance/book/v1/"+orderId ,{headers : header, observe : "body", params : httpParam,responseType : "json"})  
}
 
getAllData(OrderID:any){
  let header = new HttpHeaders();
  let httpParam : HttpParams=new HttpParams();
    return this.http.post( environment.API_URL+"/api/order/insurance/invoice/v1/"+OrderID ,{headers : header, observe : "body", params : httpParam,responseType : "json"})  
}

downloadPdf(orderId:any,policyNumber:any){
  let header = new HttpHeaders();
  // let httpParam : HttpParams=new HttpParams();
  // httpParam=httpParam.append("orderId", orderId);
  // httpParam=httpParam.append("invoiceLabel", 'C');

    return this.http.post( environment.API_URL+"/order/insurance/policy-download/"+policyNumber ,{headers : header, observe : "body",responseType : "blob"})  
}
OrderId(orderId:any,request:any){
  let header = new HttpHeaders();
  let httpParam : HttpParams=new HttpParams();
    return this.http.post( environment.API_URL+"/api/order/insurance/v1/"+orderId,request ,{headers : header, observe : "body", params : httpParam,responseType : "json"})  
}
OrderIdStatus(orderId:any){
  let header = new HttpHeaders();
  let httpParam : HttpParams=new HttpParams();
    return this.http.post( environment.API_URL+"/api/order/insurance/status/v1/"+orderId ,{headers : header, observe : "body", params : httpParam,responseType : "json"})  
}
}
